import { createSlice } from '@reduxjs/toolkit'
import { fetchPeriodPrevGroupingData } from './thunks/common';

const initialState = {
    prevGroupedData: {},
    isLoading: false,
    error: null,
    periodOneGroupedData: null,
    periodTwoGroupedData: null,
    showFullSplitView: false,
    expandPopup: false,
    helpIntroEnabled: false,
    helpIntroActiveStepElement:"", /* it will contain the id of the active step or element s */
    isHaveAccountCode: true,
    entityType: "",
    // True while the upload page is saving/processing. The Checks split view is a sibling
    // of <Outlet/> in DefaultLayout, so no page-local loading state can reach it -- this is
    // the one flag both the upload page and the split view can see.
    isUploadProcessing: false,
    // True while a Run's report build (groupedData) carries on behind the post-Run popup.
    // isUploadProcessing stays up for it (report prefetch must wait), but the Checks split
    // view's snapshot is already complete, so that view doesn't have to.
    isReportBuildInBackground: false
}

const commonSlice = createSlice({
    name: 'commonSlice',
    initialState,
    reducers: {
        addSymbols(state, action){
            state.availableSymbols = action.payload
        },
        setShowFullSplitView(state, action) {
          state.showFullSplitView = !state.showFullSplitView
        },
        setExpandPopup(state,action) {
            state.expandPopup= action.payload
        },
        setHelpIntroEnabled(state, action) {
            state.helpIntroEnabled = action.payload
        },
        setHelpIntroActiveStepElement(state, action) {
            state.helpIntroActiveStepElement = action.payload.replace(/^#/, '');
        },
        setIsHaveAccountCode(state, action) {
            state.isHaveAccountCode = action.payload
        },
        setEntityType(state, action) {
            state.entityType = action.payload;
        },
        setIsUploadProcessing(state, action) {
            state.isUploadProcessing = !!action.payload;
        },
        setIsReportBuildInBackground(state, action) {
            state.isReportBuildInBackground = !!action.payload;
        }
        // setPeriodOneGroupedData(state, action){
        //     state.periodOneGroupedData = action.payload
        // },
        // setPeriodTwoGroupedData(state, action){
        //     state.periodTwoGroupedData = action.payload
        // }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchPeriodPrevGroupingData.pending, (state) => {
          	state.isLoading = true
        })
        builder.addCase(fetchPeriodPrevGroupingData.fulfilled, (state, action) => {
            const { periodType, result } = action.payload || {};
            state.isLoading = false;
    
            if (periodType === "periodOne") {
              	state.periodOneGroupedData = result;
            } else if (periodType === "periodTwo") {
              	state.periodTwoGroupedData = result;
            }
    
            // Organize data by period type for better readability
            state.prevGroupedData[periodType] = result;
    
        })
        builder.addCase(fetchPeriodPrevGroupingData.rejected, (state, action) => {
			state.isLoading = false
			state.error = action.error.message
        })
    }
});

export const { addSymbols, data, periodOneGroupedData, periodTwoGroupedData, setShowFullSplitView, setExpandPopup, setHelpIntroEnabled ,setHelpIntroActiveStepElement, setIsHaveAccountCode, setEntityType, setIsUploadProcessing, setIsReportBuildInBackground } = commonSlice.actions

export default commonSlice;